define('js/validation-mixin',['jquery'], function($) {
    'use strict';

    return function() {
        $.validator.addMethod(
            'validate-quote-mask-id',
            function (value) {
                var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
                return value.length <= 32 && value.length >= 6 && !format.test(value);
            },
            $.mage.__('Invalid cart id format.')
        );
        $.validator.addMethod(
            'custom-phone-number-validation',
            function (value) {
                return /^07\d{9}$/.test(value);
            },
            $.mage.__('This is a required field.')
        );
        $.validator.addMethod(
            'phone-number-start-gb',
            function (value) {
                return !value || /^07/.test(value);
            },
            $.mage.__('Phone number should start with 07.')
        );
        $.validator.addMethod(
            'validate-names-with-double-barrelled',
            function (value, element) {
                return !value || /^[a-z]+([ '`´‘’-][a-z]+)*$/i.test(value);
            },
            $.mage.__('Letters, space, hyphen and apostrophe only')
        );
        $.validator.addMethod(
            'validate-surname-min-length',
            function (value, element) {
                return !value || value.length > 1;
            },
            $.mage.__('Please enter at least 2 characters')
        );
        $.validator.addMethod(
            'phone-number-length-gb',
            function (value) {
                return !value || /\d{11}$/.test(value);
            },
            $.mage.__('Phone number length should be 11 digits.')
        );
        $.validator.addMethod(
            'pac-stac-code-gb',
            function (value) {
                return /(?=(.*[a-zA-Z]){3})(?=(.*\d){6}).*^.{1,9}$/.test(value);
            },
            $.mage.__('Incorrect code format.')
        );
        $.validator.addMethod(
            'validate-pin',
            function (v, elm) {
                var reMax = new RegExp(/^maximum-pin-[0-9]+$/),
                    reMin = new RegExp(/^minimum-pin-[0-9]+$/),
                    validator = this,
                    result = true,
                    length = 0;

                $.each(elm.className.split(' '), function (index, name) {
                    if (name.match(reMax) && result) {
                        length = name.split('-')[2];
                        result = v.length <= length;
                        validator.validateMessage =
                            $.mage.__('Your one-time PIN must be %1 numbers').replace('%1', length);
                    }

                    if (name.match(reMin) && result && !$.mage.isEmpty(v)) {
                        length = name.split('-')[2];
                        result = v.length >= length;
                        validator.validateMessage =
                            $.mage.__('Your one-time PIN must be %1 numbers').replace('%1', length);
                    }
                });

                return result;
            }, function () {
                return this.validateMessage;
            }
        );
        $.validator.addMethod(
            'validate-pin-min',
            function (value) {
                return /\b\d{5}\b/g.test(value);
            },
            $.mage.__('Your one-time PIN must be 5 numbers')
        );

        $.validator.addMethod(
            'validate-dob-day', function(value) {
                var dayVal = $("#dob_dd").val(),
                    monthVal = $("#dob_mm").val(),
                    yearVal = $("#dob_yy").val(),
                    dobField = $('.customer-dob');

                if(!dayVal.length) {
                    this.dobErrorMessage = 'This is a required field.';
                    dobField.addClass('errors');
                    this.dobErrors = true;
                    return false;
                }

                if(dayVal.length < 2 && dayVal.length > 0) {
                    this.dobErrorMessage = $.mage.__('Please enter at least 2 characters.');
                    dobField.addClass('errors');
                    this.dobErrors = true;
                    return false;
                }

                var day = parseInt(dayVal, 10) || 0,
                    month = parseInt(monthVal, 10) || 0,
                    year = parseInt(yearVal, 10) || 0,
                    curYear = (new Date()).getFullYear();
                if (!day) {
                    this.dobErrorMessage = $.mage.__('Please enter a valid full date.');
                    this.dobErrors = true;
                    dobField.addClass('errors');
                    return false;
                }

                var validateDayInMonth = new Date(year, month, 0).getDate();
                if (day < 1 || day > validateDayInMonth) {
                    var validDateMessage = $.mage.__('Please enter a valid day (1-%1).');
                    this.dobErrorMessage = validDateMessage.replace('%1', validateDayInMonth.toString());
                    this.dobErrors = true;
                    dobField.addClass('errors');
                    return false;
                }
                var today = new Date(),
                    dateEntered = new Date();
                dateEntered.setFullYear(year, month - 1, day);
                if (dateEntered > today) {
                    this.dobErrorMessage = $.mage.__('Please enter a date from the past.');
                    this.dobErrors = true;
                    dobField.addClass('errors');
                    return false;
                }

                $('.customer-dob').removeClass('errors');
                this.dobErrors = false;
                return true;
            },
                function () {
                    return this.dobErrorMessage;
                }
            );

            $.validator.addMethod(
            'validate-dob-month', function(value) {

                var monthVal = $("#dob_mm").val(),
                    dobField = $('.customer-dob');

                var month = parseInt(monthVal, 10) || 0;

                if(this.dobErrors == false || this.dobErrors == null) {

                    if(!monthVal.length) {
                        this.dobErrorMessage = 'This is a required field.';
                        dobField.addClass('errors');
                        this.dobErrors = true;
                        return false;
                    }

                    if(monthVal.length < 2 && monthVal.length > 0) {
                        this.dobErrorMessage = $.mage.__('Please enter at least 2 characters.');
                        dobField.addClass('errors');
                        this.dobErrors = true;
                        return false;
                    }

                    if (month < 1 || month > 12) {
                        this.dobErrorMessage = 'Please enter a valid month.';
                        dobField.addClass('errors');
                        this.dobErrors = true;
                        return false;
                    }
                }

                dobField.removeClass('errors');

                return true;
            },
                function () {
                    return this.dobErrorMessage;
                }
            );

            $.validator.addMethod(
            'validate-dob-year', function(value) {

                var dayVal = $("#dob_dd").val(),
                    monthVal = $("#dob_mm").val(),
                    yearVal = $("#dob_yy").val(),
                    dobField = $('.customer-dob');

                var day = parseInt(dayVal, 10) || 0,
                    month = parseInt(monthVal, 10) || 0,
                    year = parseInt(yearVal, 10) || 0,
                    curYear = (new Date()).getFullYear();

                var today = new Date(),
                    dateEntered = new Date();

                dateEntered.setFullYear(year, month - 1, day);

                if(this.dobErrors == false || this.dobErrors == null) {

                    if(!yearVal.length) {
                        this.dobErrorMessage = 'This is a required field.';
                        dobField.addClass('errors');
                        this.dobErrors = true;
                        return false;
                    }

                    if (year < 1900 || year > curYear) {
                        var validYearMessage = $.mage.__('Please enter a valid year (1900-%1).');
                        this.dobErrorMessage = validYearMessage.replace('%1', curYear.toString());
                        dobField.addClass('errors');
                        this.dobErrors = true;
                        return false;
                    }
                }

                dobField.removeClass('errors');
                return true;
            },
            function () {
                return this.dobErrorMessage;
            }
        );

    }
});

